module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "dialog modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.cancel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animation-content"
  }, [(_vm.title) ? _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    class: {
      'is-titleless': !_vm.title,
      'is-flex': _vm.hasIcon
    }
  }, [_c('div', {
    staticClass: "media"
  }, [(_vm.hasIcon) ? _c('div', {
    staticClass: "media-left"
  }, [_c('b-icon', {
    class: _vm.type,
    attrs: {
      "icon": _vm.icon ? _vm.icon : _vm.iconByTpe,
      "pack": _vm.iconPack,
      "both": !_vm.icon,
      "size": "is-large custom-icon"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), (_vm.hasInput) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', _vm._b({
    ref: "input",
    staticClass: "input",
    class: {
      'is-danger': _vm.validationMessage
    },
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.prompt
    },
    on: {
      "input": function (event) { return _vm.prompt = event.target.value; },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirm.apply(null, arguments)
      }
    }
  }, 'input', _vm.tempInputAttrs, false))]), _vm._v(" "), _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.validationMessage))])]) : _vm._e()])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCancel),
      expression: "canCancel"
    }],
    ref: "cancelButton",
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cancelText) + "\n        ")]), _vm._v(" "), _c('button', {
    ref: "confirmButton",
    staticClass: "button",
    class: _vm.type,
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n          " + _vm._s(_vm.confirmText) + "\n        ")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-751f2156","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/Dialog.vue
// module id = 403
// module chunks = 56